// Down-round diagnosis from multi-anchor cross-check — emergent feature (S4). Engine layer (framework-free).
/**
 * Detect whether the multi-anchor cross-check reveals a down round: the latest
 * preferred (by issue date) implies a lower total equity value than the
 * earliest one. `isDownRound` is true only when the later point is more than
 * 10% below the earliest point.
 */
export function downRoundDiagnosis(points, cap) {
    if (points.length < 2) {
        return { isDownRound: false, laterInstrumentId: null, earlierInstrumentId: null, note: '' };
    }
    const issueDate = new Map(cap.instruments.map((i) => [i.id, i.issueDate]));
    const name = new Map(cap.instruments.map((i) => [i.id, i.name]));
    const ordered = [...points].sort((a, b) => {
        const da = issueDate.get(a.instrumentId) ?? '';
        const db = issueDate.get(b.instrumentId) ?? '';
        return da.localeCompare(db);
    });
    const earliest = ordered[0];
    const latest = ordered[ordered.length - 1];
    const isDownRound = earliest.impliedEquityValue > 0 &&
        latest.impliedEquityValue < earliest.impliedEquityValue * 0.9;
    const earlierName = name.get(earliest.instrumentId) ?? earliest.instrumentId;
    const laterName = name.get(latest.instrumentId) ?? latest.instrumentId;
    const note = isDownRound
        ? `Later preferred (${laterName}) implies a lower equity value than ${earlierName} — consistent with a down round; consider anti-dilution adjustment.`
        : '';
    return {
        isDownRound,
        laterInstrumentId: latest.instrumentId,
        earlierInstrumentId: earliest.instrumentId,
        note,
    };
}
//# sourceMappingURL=downRound.js.map